import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from '@services/core/entity.service';
import { EditOfficeComponent } from './editOffice/editOffice.component';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pickNamed } from '../named-filter.helper';

@Component({
    selector: 'app-office',
    templateUrl: './office.component.html',
    styleUrls: ["./office.component.css"],
    imports: [CommonModule, NgbTooltipModule, PanelComponent, EditOfficeComponent],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
})
export class OfficeComponent implements OnInit {
    protected offices
    protected office
    private officesTemp
    protected showEditOffice = false
    private entityService = inject(EntityService)
    private route = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)


    ngOnInit(): void {
        const data = this.route.snapshot.data['officeData']
        if (!data) return
        this.offices = data.offices
        this.officesTemp = data.officesTemp
    }

    getOffices() {
        this.office = null
        this.showEditOffice = false
        this.entityService.getOffices().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.offices = res
                this.officesTemp = res
            },
            error: (err) => console.error('Error al obtener oficinas:', err)
        })
    }

    filterOffices(value: string) {
        if (this.officesTemp) this.offices = pickNamed(this.officesTemp, value)
    }

    toggleOffice(office: any) {
        office.enabled = !office.enabled
        this.entityService.updateOffice(office).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error('Error al actualizar oficina:', err)
        })
    }

    addOffice() {
        this.office = null
        this.showEditOffice = true
    }

    setEditOffice(office: any) {
        this.office = office
    }

    moveUp(i: number) {
        if (i === 0) return
        const item = this.offices[i]
        this.offices[i] = this.offices[i - 1]
        this.offices[i - 1] = item
        this.entityService.updateOffices(this.offices).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error('Error al reordenar oficinas:', err)
        })
    }

    moveDown(i: number) {
        if (i === this.offices.length - 1) return
        const item = this.offices[i]
        this.offices[i] = this.offices[i + 1]
        this.offices[i + 1] = item
        this.entityService.updateOffices(this.offices).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error(err)
        })
    }
}
